import { http } from './http'
import { TechpackEmail, TechpackShare, Techpack } from '../types'
import { ProductTechpacksApi, ProductTechpackSharesApi } from '../generated'

export const TechpackApi = {
  async getTechpackById(productId: string, techpackId: string): Promise<{ data: unknown }> {
    const data = await http.get<unknown>(`v2/products/${productId}/techpacks/${techpackId}`)
    return data
  },

  async createTechpackShares(productId: string, techpackId: string): Promise<TechpackShare> {
    const { data } = await http.post<TechpackShare>(`/v2/products/${productId}/techpacks/${techpackId}/shares`)
    return data
  },

  async emailTechpacks(techpackEmail: TechpackEmail): Promise<void> {
    http.post(`/v2/products/techpacks/email`, techpackEmail)
  },

  async getTechpacks(productId: string): Promise<Array<Techpack>> {
    const { data } = await http.get<Array<Techpack>>(`v2/products/${productId}/techpacks`)
    return Array.isArray(data) ? data : []
  },

  async getSignedUrl(productId: string, techpackId: string): Promise<string> {
    const { data } = await http.get<string>(`v2/products/${productId}/techpacks/${techpackId}/signed-url`)
    return data
  },

  async delete(productId: string, techpackId: string): Promise<void> {
    return http.delete(`v2/products/${productId}/techpacks/${techpackId}`)
  },

  async createTechpackShare(productId: string, techpackId: string): Promise<TechpackShare> {
    const { data } = await http.post<TechpackShare>(`v2/products/${productId}/techpacks/${techpackId}/shares`)
    return data
  },

  async emailTechpackShareLink(productId: string, techpackId: string, email: TechpackEmail): Promise<void> {
    return http.post(`v2/products/${productId}/techpacks/${techpackId}/email-share`, email)
  }
}

export const productTechpacksApi = new ProductTechpacksApi(undefined, `${http.http.defaults.baseURL}/v2`, http.http)
export const productTechpackSharesApi = new ProductTechpackSharesApi(
  undefined,
  `${http.http.defaults.baseURL}/v2`,
  http.http
)
